<template>
  <li class="scroller scroll-snap" :class="{ 'scroll-snap-active': centerPlansActive }">
    <slot></slot>
  </li>
</template>
<script>
export default {
  data: () => {
    return {
      centerPlansActive: true
    };
  },
  mounted() {
    setTimeout(() => {
      this.centerPlansActive = !this.centerPlansActive;
    }, 1000);
  }
};
</script>
<style lang="scss" scoped>
.scroller {
  display: flex;
  overflow-x: auto;
  padding: 2em;
  @include min-md {
    overflow-x: visible;
    padding: 0;
  }
}
.scroll-snap.scroll-snap-active {
  scroll-snap-type: x mandatory;
}
</style>
